import React, { useEffect, useState } from "react";
import { Row, Col, Space, Modal } from "antd";
import { HSdecrypt } from "../../utils/encryptPassword";
import AuthService from "../../Services/AuthService";
import ViewPrescriptionHS from "./ViewPrescriptionHS";
import PatientService from "../../Services/PatientService";

function Prescription(props) {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedPrescription, setSelectedPrescription] = useState({});
  const [patDetails, setPatDetails] = useState(null);

  const [isLoading, setIsLoading] = useState(false);
  // const patJson = localStorage.getItem("patientData");
  // const patObj = patJson ? JSON.parse(patJson) : null;
  // const patientCode = patObj?.patientId;
  const [prescriptionsList, setPrescriptionsList] = useState([]);

  const getPatientDetails = async () => {
    const payload = {
      patientId: props?.selectedPatient,
    };

    try {
      const response = await PatientService.HSPatientData(payload);
      setPatDetails(response.data[0]);
    } catch (e) {
      console.error(e);
    }
  };

  const patientName = `${patDetails?.salutation || ""} ${
    patDetails?.firstName || ""
  } ${patDetails?.lastName || ""}`.trim();

  const fetchAllPrescriptions = async () => {
    setIsLoading(true);
    let payload = {
      patientId: props?.selectedPatient,
      detailsYN: "Y",
      status: 2,
    };
    // Corrected this part to chain the then and catch properly
    AuthService.getHSMyPrescriptionView(payload)
      .then((result) => {
        const decryptedData = HSdecrypt(result.data.data);
        setPrescriptionsList(JSON.parse(decryptedData));
        setIsLoading(false);
      })
      .catch((error) => {
        console.error(error);
        setIsLoading(false);
      });
  };
  useEffect(() => {
    fetchAllPrescriptions();
    getPatientDetails();
  }, []);

  const handleClickPres = (presc) => {
    setIsModalOpen(true);
    setSelectedPrescription(presc);
  };

  const handleOk = () => {
    setIsModalOpen(false);
  };
  const handleCancel = () => {
    setIsModalOpen(false);
  };
  return (
    <div>
      <Row gutter={[16, 16]} className="p-4">
        {prescriptionsList.map((record) => (
          <Col xs={24} sm={12} md={8} lg={8} xl={8} key={record.appointmentId}>
            <div className="bg-white p-4 rounded-lg shadow-md hover:shadow-lg transition-shadow">
              <div className="space-y-2">
                {/* Patient Name and Appointment ID */}
                <div className="flex justify-between items-start">
                  <h3 className="font-semibold text-lg">{patientName}</h3>
                  <span className="text-gray-500 text-sm">
                    {record.appointmentId}
                  </span>
                </div>

                {/* Consultation Reason */}
                <p className="text-gray-600 text-sm">
                  {record.consultationReason}
                </p>

                {/* Doctor and Clinic Info */}
                <div className="flex justify-between gap-2">
                  <span className="bg-blue-100 text-[#189FAA] text-xs px-2 py-1 rounded">
                    {record.userName}
                  </span>
                  <span className="bg-gray-100 text-gray-800 text-xs px-2 py-1 rounded">
                    {record.clinic_Name}
                  </span>
                </div>

                {/* Date and Action Button */}
                <div className="flex justify-between items-center pt-2 border-t border-gray-100">
                  <span className="text-sm text-gray-500">
                    {record?.consultationDate?.slice(0, 10)}
                  </span>
                  <button
                    className="px-3 py-1.5 rounded-md bg-color1 text-white text-sm hover:bg-opacity-90 transition-colors"
                    onClick={() => handleClickPres(record)}
                  >
                    View Prescription
                  </button>
                </div>
              </div>
            </div>
          </Col>
        ))}
      </Row>

      <Modal
        // title="View Prescription"
        visible={isModalOpen}
        onOk={handleOk}
        onCancel={handleCancel}
        style={{ top: 20 }}
        width={1000}
        footer={false}
        // footer={[
        //   <div className="flex items-center justify-end gap-2">
        //     <button className="text-white bg-brand-primaryColor w-44 h-12  rounded-lg ">
        //       Download Prescription
        //     </button>
        //   </div>
        // ]}
      >
        <ViewPrescriptionHS
          prescription={selectedPrescription}
          selectedPatient={patDetails}
        />
      </Modal>
    </div>
  );
}

export default Prescription;
